
import NavLinks from "./NavLinks";
import SocialIcons from "./SocialIcons";
import { Button } from "../ui/button";
import { LeadFormModal } from "../modals/LeadFormModal";
import { useAuth } from "@/hooks/useAuth";
import { Link } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";

interface MobileMenuProps {
  isOpen: boolean;
  scrollToSection: (id: string) => void;
}

const MobileMenu = ({ isOpen, scrollToSection }: MobileMenuProps) => {
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const { user, isAuthenticated, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    toast.success('Sesión cerrada exitosamente');
  };

  const openContact = () => setContactModalOpen(true);
  const closeContact = () => setContactModalOpen(false);

  if (!isOpen) return null;


  return (
    <>
      <div className="lg:hidden bg-white/95 backdrop-blur-md shadow-lg absolute top-full left-0 w-full animate-slide-down">
        <div className="container mx-auto px-4 py-5 space-y-5">
          <NavLinks scrollToSection={scrollToSection} isMobile={true} />
          
          {/* Authentication Section */}
          <div className="pt-4 border-t border-gray-200">
            {isAuthenticated ? (
              <div className="space-y-3">
                <div className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground bg-muted rounded-md">
                  <User className="h-4 w-4" />
                  <span>{user?.email}</span>
                </div>
                <Button
                  onClick={handleSignOut}
                  variant="outline"
                  className="w-full font-araboto font-medium text-base py-3"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Cerrar Sesión
                </Button>
              </div>
            ) : (
              <div className="space-y-3">
                <Link to="/auth" className="block">
                  <Button
                    variant="outline"
                    className="w-full font-araboto font-medium text-base py-3"
                  >
                    Iniciar Sesión
                  </Button>
                </Link>
                <Button
                  onClick={openContact}
                  className="w-full font-araboto font-medium text-base py-3 bg-primary hover:bg-primary/90 text-primary-foreground"
                >
                  Contáctanos
                </Button>
              </div>
            )}
          </div>
          
          <div className="flex pt-4 border-t border-gray-200">
            <SocialIcons iconSize={24} />
          </div>
        </div>
      </div>
      
      <LeadFormModal
        isOpen={contactModalOpen}
        onClose={closeContact}
        route="/contacto"
      />
    </>
  );
};

export default MobileMenu;
